<template>
  <div :id="pageName ? pageName : 'forecast-history'" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />

    <div class="row pb-5">
      <div class="col">
        <div class="table-responsive">
          <table :id="tableID" class="table" style="white-space: nowrap">
            <thead>
              <tr>
                <th
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                ></th>
                <th
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                >
                  {{ fcHistoryPage.FCHistoryTable.Header1 }}
                </th>
                <th
                  v-if="fcHistoryPage.FCHistoryTable.WasRevised1 !== null"
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                ></th>
                <th
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                >
                  {{ fcHistoryPage.FCHistoryTable.Header2 }}
                </th>
                <th
                  v-if="fcHistoryPage.FCHistoryTable.WasRevised2 !== null"
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                ></th>
                <th
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                >
                  {{ fcHistoryPage.FCHistoryTable.Header3 }}
                </th>
                <th
                  v-if="fcHistoryPage.FCHistoryTable.WasRevised3 !== null"
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                ></th>
                <th
                  class="tableHeader"
                  style="background: #3075a4; border: none"
                >
                  {{ fcHistoryPage.FCHistoryTable.Header4 }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(data, key) in fcHistoryPage.FCHistoryTable.Rows"
                :key="key"
              >
                <tr
                  :class="[
                    data.RowTitle === 'Actual'
                      ? 'fcActual font-weight-bold'
                      : '',
                    data.RowTitle.includes('Annual') ||
                    data.RowTitle.includes('Quarterly')
                      ? 'fcAnnualRow font-weight-bold'
                      : '',
                  ]"
                >
                  <td
                    class="font-weight-bold fcBorderLeft"
                    :class="[
                      key === 4 || key === 9
                        ? 'fcBorderBottom fcBorderBottomRadiusLeft'
                        : '',
                      key === 5 || key === 10
                        ? 'fcBorderTop fcBorderTopRadiusLeft'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom fcBorderBottomRadiusLeft'
                        : '',
                      key > 10 &&
                      fcHistoryPage.FCHistoryTable.Rows[key - 1].RowTitle ===
                        'Actual'
                        ? 'fcBorderTop fcBorderTopRadiusLeft'
                        : '',
                    ]"
                  >
                    {{ data.RowTitle }}
                  </td>

                  <td
                    class="text-center"
                    :class="[
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom'
                        : '',
                    ]"
                    :style="
                      data.RowTitle.includes('Actual')
                        ? parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].FirstColumn
                          ) >=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[5].FirstColumn
                            ) &&
                          parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].FirstColumn
                          ) <=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[7].FirstColumn
                            )
                          ? 'color: #09A684'
                          : 'color: #D2232A;'
                        : ''
                    "
                  >
                    {{ data.FirstColumn }}
                  </td>

                  <td
                    v-if="fcHistoryPage.FCHistoryTable.WasRevised1 !== null"
                    :class="[
                      fcHistoryPage.FCHistoryTable.WasRevised1 !== null
                        ? 'noTableBorder'
                        : '',
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom'
                        : '',
                    ]"
                  >
                    <p
                      v-if="key === 8"
                      class="verticalText forecastAddOnRevisionText"
                      style="font-weight: normal"
                    >
                      {{ fcHistoryPage.FCHistoryTable.WasRevised1 }}
                    </p>
                  </td>

                  <td
                    class="text-center"
                    :class="[
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom'
                        : '',
                    ]"
                    :style="
                      data.RowTitle.includes('Actual')
                        ? parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].SecondColumn
                          ) >=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[5].SecondColumn
                            ) &&
                          parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].SecondColumn
                          ) <=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[7].SecondColumn
                            )
                          ? 'color: #09A684'
                          : 'color: #D2232A;'
                        : ''
                    "
                  >
                    {{ data.SecondColumn }}
                  </td>

                  <td
                    v-if="fcHistoryPage.FCHistoryTable.WasRevised2 !== null"
                    :class="[
                      fcHistoryPage.FCHistoryTable.WasRevised2 !== null
                        ? 'noTableBorder'
                        : '',
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom'
                        : '',
                    ]"
                  >
                    <p
                      v-if="key === 8"
                      class="verticalText forecastAddOnRevisionText"
                      style="font-weight: normal"
                    >
                      {{ fcHistoryPage.FCHistoryTable.WasRevised2 }}
                    </p>
                  </td>

                  <td
                    class="text-center"
                    :class="[
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom'
                        : '',
                    ]"
                    :style="
                      data.RowTitle.includes('Actual')
                        ? parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].ThirdColumn
                          ) >=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[5].ThirdColumn
                            ) &&
                          parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].ThirdColumn
                          ) <=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[7].ThirdColumn
                            )
                          ? 'color: #09A684'
                          : 'color: #D2232A;'
                        : ''
                    "
                  >
                    {{ data.ThirdColumn }}
                  </td>

                  <td
                    v-if="fcHistoryPage.FCHistoryTable.WasRevised3 !== null"
                    :class="[
                      fcHistoryPage.FCHistoryTable.WasRevised3 !== null
                        ? 'noTableBorder'
                        : '',
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom'
                        : '',
                    ]"
                  >
                    <p
                      v-if="key === 8"
                      class="verticalText forecastAddOnRevisionText"
                      style="font-weight: normal"
                    >
                      {{ fcHistoryPage.FCHistoryTable.WasRevised3 }}
                    </p>
                  </td>

                  <td
                    class="text-center fcBorderRight"
                    :class="[
                      key === 5 || key === 10 ? 'fcBorderTopRadiusRight' : '',
                      key === 4 || key === 9
                        ? 'font-weight-bold fcBorderBottom fcBorderBottomRadiusRight'
                        : '',
                      key > 10 && data.RowTitle === 'Actual'
                        ? 'fcBorderBottom fcBorderBottomRadiusRight'
                        : '',
                      key > 10 &&
                      fcHistoryPage.FCHistoryTable.Rows[key - 1].RowTitle ===
                        'Actual'
                        ? 'fcBorderTopRadiusRight'
                        : '',
                    ]"
                    :style="
                      data.RowTitle.includes('Actual')
                        ? parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].FourthColumn
                          ) >=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[5].FourthColumn
                            ) &&
                          parseFloat(
                            fcHistoryPage.FCHistoryTable.Rows[8].FourthColumn
                          ) <=
                            parseFloat(
                              fcHistoryPage.FCHistoryTable.Rows[7].FourthColumn
                            )
                          ? 'color: #09A684'
                          : 'color: #D2232A;'
                        : ''
                    "
                  >
                    {{ data.FourthColumn }}
                  </td>
                </tr>
                <tr
                  v-if="
                    key === 4 ||
                    key === 9 ||
                    (key > 10 && data.RowTitle === 'Actual')
                  "
                  v-bind:key="key"
                  class="bg-white"
                >
                  <td class="border-0 text-light" height="25px"></td>
                  <td class="border-0 text-light" height="25px"></td>
                  <td
                    v-if="fcHistoryPage.FCHistoryTable.WasRevised1 !== null"
                    class="border-0 text-light"
                    height="25px"
                  ></td>
                  <td class="border-0 text-light" height="25px"></td>
                  <td
                    v-if="fcHistoryPage.FCHistoryTable.WasRevised2 !== null"
                    class="border-0 text-light"
                    height="25px"
                  ></td>
                  <td class="border-0 text-light" height="25px"></td>
                  <td
                    v-if="fcHistoryPage.FCHistoryTable.WasRevised3 !== null"
                    class="border-0 text-light"
                    height="25px"
                  ></td>
                  <td class="border-0 text-light" height="25px"></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-large-12 col-medium-6 pb-3 mt-3">
        <label class="cards" style="background: #183961">
          Forecast Revision History
        </label>
        <ul class="cardsList p-4">
          <li
            class="list3"
            v-for="(row, index) in fcHistoryPage.ForecastRevisions"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'ForecastHistoryComponent',
    components: {
      ReportHeader,
    },
    props: {
      companyName: String,
      fcHistoryPage: Object,
      consulting_slug: String,
      tableID: String,
      pageName: String,
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `Forecast History for ${this.fcHistoryPage.PageTitle}`;
      },
      subtitle() {
        return ``;
      },
    },
  };
</script>
